import { observable } from "mobx";

export default class DetalhamentoHistoricoFluxoStore {
    @observable activeTab;

    constructor() {
        this.activeTab = '1';
    }

    toggle = (tab) => {
        if (this.activeTab !== tab) {
            this.activeTab = tab;
        }
    }

    tarefaPresenteTarefasRealizadas(tarefa, tarefasRealizadas){
        return tarefasRealizadas.filter(tr => tr.nomeTarefa == tarefa.nomeTarefa && tr.tipoFluxo == tarefa.tipoFluxo).length > 0;
    }

    tarefaCorrespondenteTarefasRealizadas(tarefa, tarefasRealizadas){
        return tarefasRealizadas.filter(tr => tr.nomeTarefa == tarefa.nomeTarefa && tr.tipoFluxo == tarefa.tipoFluxo)[0];
    }

    removerTarefasRealizadasFluxo(tarefasRealizadas, tarefasFluxo){
        return tarefasFluxo.filter( function( tarefa ) {
            return !(this.tarefaPresenteTarefasRealizadas(tarefa, tarefasRealizadas));
        } , this );
    }

    copiarResponsavel(tarefasRealizadas, tarefasFluxo){
        const tarefasFluxoCopy = JSON.parse(JSON.stringify(tarefasFluxo));
        return tarefasFluxoCopy.map( function( tarefa ) {
            const tarefaCorrespondente = this.tarefaCorrespondenteTarefasRealizadas(tarefa, tarefasRealizadas)
            if(tarefaCorrespondente !== undefined) {
                tarefa.historico = true;
                tarefa.responsavel = tarefaCorrespondente.responsavel;
            }
            return tarefa;
        } , this );
    }

    removerTarefasSemUsuario(tarefasFluxo){
        return tarefasFluxo.filter(tr => (tr.responsavel !== null && tr.responsavel !== "") || tr.tarefaAtual === true
            || tr.tipoTarefa === 'HT_ConfirmarAlocacao' || tr.tipoTarefa === 'HT_ConfirmarContratacaoETT');
    }

    removerTarefasNaoRealizadas(tarefasFluxo){
        let indexTarefaAtual = tarefasFluxo.findIndex(tarefa => tarefa.tarefaAtual === true);
        return tarefasFluxo.filter( function( tarefa, i ) {
            return( i >= indexTarefaAtual || tarefa.historico === true) ;
        } );
    }
}